<template>
  <v-btn
    :type="type"
    class="btn d-flex justify-content-center align-items-center"
    :disabled="disabled || (loading && showLoading)"
    :class="btnClass"
    variant="outlined"
    v-bind="$attrs"
  >
    <span
      v-if="showLoading"
      v-show="loading"
      class="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true"
    ></span>
    <slot> </slot>
  </v-btn>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button",
    },
    showLoading: {
      type: Boolean,
      default: false,
    },
    loadingKey: {
      type: String,
      default: null,
    },
    btnClass: Object,
  },
  created() {},
  computed: {
    loading() {
      return typeof this.loadingKey !== 'undefined' ? this.$store.getters[this.loadingKey] : this.$store.state.auth.loading;
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
  },
};
</script>
<style lang="scss" scoped>
.btn__blue {
  min-width: 106px;
}
</style>
